





































import Vue from 'vue';

export default Vue.extend({
  props: {
    for: { type: String, default: undefined },
    label: { type: String, default: undefined },
    required: { type: Boolean },
    stacked: { type: Boolean },
    horizontal: { type: Boolean, default: false },
    invalid: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    fieldset: {
      type: Boolean,
      default: false,
    },
    legend: {
      type: String,
      default: undefined,
    },
    error: {
      type: String,
      default: undefined,
    },
    pseudo: {
      type: Boolean,
      default: false,
    },
  },
});
